<div class="articles" *ngIf="posts && posts.length > 0">
    <div *ngFor="let post of posts">
        <div class="image"  routerLink="/blog/article/{{post.fields.slug}}"  [style.backgroundImage]="'url(https:'+ post.fields.heroImage?.fields.file.url +'?w=390&h=220)'"></div>
        <strong class="title" routerLink="/blog/article/{{post.fields.slug}}" routerDirection="forward"
        *ngIf="post.fields.title">{{post.fields.title}}</strong>
        <p class="muted">{{ post.fields.description | ellipsis:150 }}</p>
    </div>
</div>